import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CustomerIdentityCustomerDetail from '../CustomerIdentity/CustomerDetail';
import CustomerIdentityCustomers from '../CustomerIdentity/CustomersAdmin';
import CustomerDataImport from '../CustomerIdentity/CustomerDataImport';
import LearnedAssociations from '../CustomerIdentity/LearnedAssociations';
import CustomerIdentityUsers from '../CustomerIdentity/CustomerIdentityUsers';
import ShipToAddressesDirectory from '../CustomerIdentity/ShipToAddressesDirectory';
import ContactsDirectory from '../CustomerIdentity/ContactsDirectory';
import CustomerIdentityUserGroups from '../CustomerIdentity/CustomerIdentityUserGroups';
import CustomerIdentityPlatformUsers from '../CustomerIdentity/PlatformUsers';
import CustomerIdentitySettings from '../CustomerIdentity/Settings';
import CustomerIdentitySiteDetail from '../CustomerIdentity/SiteDetail';
import CustomerIdentitySites from '../CustomerIdentity/Sites';

import { CiAdminAuthProvider } from '../../contexts/CiAdminAuthContext';
import { CiSiteFilterProvider } from '../../contexts/CiSiteFilterContext';

/**
 * Embedded Customer Identity admin: rendered inside the main app's
 * MainLayout under `/customer-identity/*`. Uses the host SPA's existing
 * auth (OAuth/API-key) and treats the caller as a super-admin (`scope='all'`).
 */
export default function CustomerIdentityEmbedded() {
  return (
    <CiAdminAuthProvider mode="account">
      <CiSiteFilterProvider>
      <div className="ci-ui flex-grow-1 d-flex flex-column min-vh-0">
      <Routes>
        <Route index element={<Navigate to="sites" replace />} />
        <Route path="sites" element={<CustomerIdentitySites />} />
        <Route path="sites/:siteId" element={<CustomerIdentitySiteDetail />} />
        <Route path="customers" element={<CustomerIdentityCustomers />} />
        <Route
          path="customers/:customerId"
          element={<CustomerIdentityCustomerDetail />}
        />
        <Route path="users" element={<CustomerIdentityUsers />} />
        <Route path="shipto-addresses" element={<ShipToAddressesDirectory />} />
        <Route path="contacts" element={<ContactsDirectory />} />
        <Route path="user-groups" element={<CustomerIdentityUserGroups />} />
        <Route path="settings" element={<CustomerIdentitySettings />} />
        <Route
          path="platform-users"
          element={<CustomerIdentityPlatformUsers />}
        />
        <Route path="customer-import" element={<CustomerDataImport />} />
        <Route path="learned-associations" element={<LearnedAssociations />} />
        <Route path="*" element={<Navigate to="sites" replace />} />
      </Routes>
      </div>
      </CiSiteFilterProvider>
    </CiAdminAuthProvider>
  );
}
